import { LiveStreamGiveawayItemApi } from '../../generated/api';
import configuration from './configuration';

export const liveStreamGiveawayService = new LiveStreamGiveawayItemApi(
  configuration,
);
